module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_04.78d27524.jpg";